<template>

  <div id="buttomLeft" style="width: 600px;height:400px;"></div>
</template>

<script>
  import echarts from 'echarts'
  export default {

    data() {
      return {

        dataXList: [],
        data1: [],
        data2: [],
      }

    },
    props: {
      record: {
        type: Array,
      },
    },
    watch: {
      record: {
        handler: function(newVal) {
          if (!newVal) {
            return
          }
          

          for (var i = 0; i < newVal.length; i++) {

            this.dataXList.push(this.dateFormat("YYYY-mm-dd", new Date(newVal[i].days)));
            this.data1.push(newVal[i].sendCount);
            this.data2.push(newVal[i].failCount);
          }
          
          this.drawLine();
        },

      },

    },
    mounted() {
      

    },
    methods: {

      // 格式化日期
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      },

      drawLine() {
        var app = {};

        var chartDom = document.getElementById('buttomLeft');
        var myChart = echarts.init(chartDom);
        var option;

        var posList = [
          'left', 'right', 'top', 'bottom',
          'inside',
          'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
          'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
        ];

        app.configParameters = {
          rotate: {
            min: -90,
            max: 90
          },
          align: {
            options: {
              left: 'left',
              center: 'center',
              right: 'right'
            }
          },
          verticalAlign: {
            options: {
              top: 'top',
              middle: 'middle',
              bottom: 'bottom'
            }
          },
          position: {
            options: posList.reduce(function(map, pos) {
              map[pos] = pos;
              return map;
            }, {})
          },
          distance: {
            min: 0,
            max: 100
          }
        };

        app.config = {
          rotate: 90,
          align: 'left',
          verticalAlign: 'middle',
          position: 'insideBottom',
          distance: 15,
          onChange: function() {
            var labelOption = {
              normal: {
                rotate: app.config.rotate,
                align: app.config.align,
                verticalAlign: app.config.verticalAlign,
                position: app.config.position,
                distance: app.config.distance
              }
            };
            myChart.setOption({
              series: [{
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }, {
                label: labelOption
              }]
            });
          }
        };


        var labelOption = {
          show: true,
          position: app.config.position,
          distance: app.config.distance,
          align: app.config.align,
          verticalAlign: app.config.verticalAlign,
          rotate: app.config.rotate,
          formatter: '{c}  {name|{a}}',
          fontSize: 16,
          rich: {
            name: {}
          }
        };

        option = {
          title: {
            text: '收发条数'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['发送报文条数', '未收到回复报文条数']
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            left: 'right',
            top: 'center',
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ['line', 'bar', 'stack', 'tiled']
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          xAxis: [{
            type: 'category',
            axisTick: {
              show: false
            },
            data: this.dataXList
          }],
          yAxis: [{
            type: 'value'
          }],
          series: [{
              name: '发送报文条数',
              type: 'bar',
              barGap: 0,
              emphasis: {
                focus: 'series'
              },
              data: this.data1
            },
            {
              name: '未收到回复报文条数',
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: this.data2
            },
            /* {
              name: 'Desert',
              type: 'bar',
              label: labelOption,
              emphasis: {
                focus: 'series'
              },
              data: [150, 232, 201, 154, 190]
            },
            {
              name: 'Wetland',
              type: 'bar',
              label: labelOption,
              emphasis: {
                focus: 'series'
              },
              data: [98, 77, 101, 99, 40]
            } */
          ]
        };

        option && myChart.setOption(option);

      }

    }, // methods

  } // default
</script>

<style>
</style>
